import { t } from "i18next";
import Drawer from "../../../../drawer/Drawer";
import PromoterDetails from "../PromoterDetails";

const PromoterDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={close}
      actualSize={"lg"}
      size={"xl3"}
      title={
        <span className="tracking-tighter uppercase font-bold">
          {t("Promoter Details")}
        </span>
      }
      subtitle={t("View detailed promoter information and commission settings")}
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-auto scrollbar"
    >
      <PromoterDetails data={data} />
    </Drawer>
  );
};

export default PromoterDetailsDrawer;
